/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import Popup from '@/components/PopUp';

export default function extend(_Vue) {
  async function popupAsync(vm, {
    message,
    showConfirm = true,
    showCancel = true,
    showClose = true,
    maskClose = false
  }) {
    return new Promise((resolve, reject) => {
      if (!vm.$root.$el) {
        reject(new Error('root element not initialized'));
      }

      const PopupComponent = _Vue.extend(Popup);
      const $component = new PopupComponent({
        data() {
          return {
            message,
            showConfirm,
            showCancel,
            showClose
          };
        },
        methods: {
          confirm() {
            resolve(true);
            $component.$el.remove();
          },
          cancel() {
            resolve(false);
            $component.$el.remove();
          },
          close() {
            resolve();
            $component.$el.remove();
          },
          maskClicked() {
            if (maskClose) {
              resolve();
              $component.$el.remove();
            }
          }
        }
      });

      $component.$mount();
      vm.$root.$el.appendChild($component.$el);
    });
  }

  class PopUpObject {
    constructor(vm) {
      this._vm = vm;
    }

    /**
   * notice 方法
   * 沒有任何按鈕
   * 無回傳
   * @param {HtmlString} message                   - 訊息(可使用html)
   * @param {Object}     [options]                 - 選項(maskClose: 是否可透過點擊遮罩關閉)
   * @param {Boolean}    [options.maskClose=false] - 是否可透過點擊遮罩關閉
   */
    notice(message, options = { maskClose: false }) {
      popupAsync(this._vm, {
        message,
        showConfirm: false,
        showCancel: false,
        showClose: false,
        maskClose: options.maskClose
      });
    }

    /**
     * alert 方法
     * 只有確認按鈕
     * 無回傳
     * @param {HtmlString} message - 訊息(可使用html)
     * @param {Boolean}    [options.Close=false] - 是否顯示右上角☓
     */
    alert(message, options = { Close: false }) {
      popupAsync(this._vm, {
        message, showCancel: false, showClose: options.Close
      });
    }

    /**
     * 非同步 alert 方法
     * 只有確認按鈕
     * @param {HtmlString} message - 訊息(可使用html)
     * @param {Boolean}    [options.Close=false] - 是否顯示右上角☓
     */
    alertAsync(message, options = { Close: false }) {
      return popupAsync(this._vm, {
        message, showConfirm: true, showCancel: false, showClose: options.Close
      });
    }

    /**
   * 同步 callback confirm 方法
   * 有確認和取消按鈕
   * @param {HtmlString} message           - 訊息(可使用html)
   * @param {Object}     [options]         - 選項
   * @param {Boolean}    [options.Close=false] - 是否顯示右上角☓
   * @param {Function}   [options.confirm] - 確認後的 callback
   * @param {Function}   [options.cancel]  - 取消後的 callback
   */
    confirm(message, { confirm, cancel }, options = { Close: false }) {
      popupAsync(this._vm, {
        message, showConfirm: true, showCancel: true, showClose: options.Close
      }).then((result) => {
        if (result) {
          if (typeof confirm === 'function') confirm();
        } else if (typeof cancel === 'function') cancel();
      });
    }

    /**
   * 非同步 confirm 方法
   * 有確認和取消按鈕
   * 若按下確認回傳 true
   * 若按下取消回傳 false
   * @param {HtmlString} message           - 訊息(可使用html)
   * @param {Object}     [options]         - 選項
   * @param {Function}   [options.confirm] - 確認後的 callback
   * @param {Function}   [options.cancel]  - 取消後的 callback
   */
    confirmAsync(message) {
      return popupAsync(this._vm, {
        message, showConfirm: true, showCancel: true, showClose: false
      });
    }

    /**
   * 非同步 popup 方法
   * 若按下確認回傳 true
   * 若按下取消回傳 false
   * 若按下關閉回傳 undefined
   * @param {Object} [options]             - 選項
   * @param {Object} [options.message]     - 訊息(可使用html)
   * @param {Object} [options.showConfirm] - 是否顯示確認
   * @param {Object} [options.showCancel]  - 是否顯示取消
   * @param {Object} [options.showClose]   - 是否顯示右上角☓
   */
    popupAsync({
      message, showConfirm, showCancel, showClose
    }) {
      return popupAsync(this._vm, {
        message, showConfirm, showCancel, showClose
      });
    }

    /**
   * 同步 callback popup 方法
   * @param {Object}     [options]         - 選項
   * @param {Function}   [options.confirm] - 確認後的 callback
   * @param {Function}   [options.cancel]  - 取消後的 callback
   * @param {Function}   [options.close]   - 關閉後的 callback
   */
    popup({
      message, confirm, cancel, close
    }) {
      const showConfirm = confirm !== undefined;
      const showCancel = cancel !== undefined;
      const showClose = close !== undefined;
      popupAsync(this._vm, {
        message, showConfirm, showCancel, showClose
      }).then((result) => {
        if (result === undefined) {
          if (typeof close === 'function') close();
        } else if (result) {
          if (typeof confirm === 'function') confirm();
        } else if (typeof cancel === 'function') cancel();
      });
    }
  }

  Object.defineProperty(_Vue.prototype, '$popup', {
    get() {
      return new PopUpObject(this);
    }
  });
}
